var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChickenBonds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 96,
    fill: "url(#paint0_linear_11_517)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9983 47.4688C78.963 47.4688 63.9779 56.2468 55.3195 69.5263L95.998 93.0121L110.637 84.5605V49.7157C106.018 48.256 101.1 47.4688 95.9983 47.4688ZM47.4718 95.9952C47.4718 88.0768 49.3684 80.6013 52.7322 73.9983L90.8315 95.995L52.732 117.992C49.3684 111.389 47.4718 103.913 47.4718 95.9952ZM115.803 81.5776L136.677 69.5262C131.604 61.7459 124.359 55.5108 115.803 51.681V81.5776ZM139.264 73.9981L55.3193 122.464C63.9777 135.743 78.9629 144.522 95.9983 144.522C122.799 144.522 144.525 122.796 144.525 95.9952C144.525 88.0767 142.628 80.6012 139.264 73.9981ZM42.3053 95.9952C42.3053 66.3414 66.3445 42.3022 95.9983 42.3022C125.652 42.3022 149.691 66.3414 149.691 95.9952C149.691 125.649 125.652 149.688 95.9983 149.688C66.3445 149.688 42.3053 125.649 42.3053 95.9952ZM104.887 68.2169C104.887 73.126 100.908 77.1056 95.9987 77.1056C91.0896 77.1056 87.11 73.126 87.11 68.2169C87.11 63.3079 91.0896 59.3283 95.9987 59.3283C100.908 59.3283 104.887 63.3079 104.887 68.2169Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_517",
    x1: 96,
    y1: 0,
    x2: 96,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C5EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163486"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenBonds);
export default __webpack_public_path__ + "static/media/chicken-bonds.7fa89e97abbd19c16dd69ddc3456b905.svg";
export { ForwardRef as ReactComponent };